import type { MagentoSession, UserSession } from "#api/models/MagentoSession"
import type { UserProfile } from "#api/services/UserProfile"
import { makeRpcClient } from "effect-app/client"
import { ApiClientFactory } from "effect-app/client/apiClientFactory"
import { DatabaseError, InvalidStateError, NotFoundError, NotLoggedInError, OptimisticConcurrencyException, ServiceUnavailableError, UnauthorizedError } from "effect-app/client/errors"
import * as Layer from "effect-app/Layer"
import { DefaultGenericMiddlewares } from "effect-app/middleware"
import { MiddlewareMaker, RpcContextMap, RpcMiddleware } from "effect-app/rpc"
import * as S from "effect-app/Schema"

const MagentoErrorUnion = S.Union([NotLoggedInError, InvalidStateError])

export const RequestContextMap = RpcContextMap.makeMap({
  allowAnonymous: RpcContextMap.makeInverted<UserProfile>()(NotLoggedInError),
  requireMagentoSession: RpcContextMap.make<MagentoSession>()(MagentoErrorUnion),
  requireSession: RpcContextMap.make<UserSession>()(NotLoggedInError)
})

export class AllowAnonymous extends RpcMiddleware.Tag<AllowAnonymous>()("AllowAnonymous", {
  dynamic: RequestContextMap.get("allowAnonymous")
}) {
}

export class RequireMagentoSession extends RpcMiddleware.Tag<RequireMagentoSession>()("RequireMagentoSession", {
  dynamic: RequestContextMap.get("requireMagentoSession")
}) {
}

export class RequireSession extends RpcMiddleware.Tag<RequireSession>()("requireSession", {
  dynamic: RequestContextMap.get("requireSession")
}) {
}

export class AppMiddleware extends MiddlewareMaker
  .Tag<AppMiddleware>()("AppMiddleware", RequestContextMap)
  .middleware(AllowAnonymous, RequireSession, RequireMagentoSession)
  .middleware(...DefaultGenericMiddlewares)
{
}

const Sup = S.Union([
  InvalidStateError,
  OptimisticConcurrencyException,
  UnauthorizedError,
  NotFoundError,
  NotLoggedInError,
  ServiceUnavailableError,
  DatabaseError
])

// TODO: support middleware error elimination for e.g S.Parseresult.ParseError?
export const { TaggedRequestFor } = makeRpcClient(AppMiddleware, Sup) // TODO: this is a cop out

// v4: request caching/batching layer helpers were removed; using Layer.empty
export const clientFor = ApiClientFactory.makeFor(Layer.empty, { skipQueryKey: ["Admin"] })
